import { get } from 'lodash';

class AccountPassFormErrorModel {
    constructor() {
        this.flattenedErrors = {
            currentPassword: null,
            newPassword: null,
            confirmNewPassword: null,
        };
    }

    setFormErrors(errors) {
        this.flattenErrors(errors);
    }

    flattenErrors(errors) {
        this.flattenedErrors.currentPassword = get(errors, 'children.currentPassword.errors');
        this.flattenedErrors.newPassword = get(errors, 'children.password.children.first.errors');
        this.flattenedErrors.confirmNewPassword = get(errors, 'children.password.children.second.errors');
    }

    get currentPassword() {
        return this.flattenedErrors['currentPassword'];
    }

    get newPassword() {
        return this.flattenedErrors['newPassword'];
    }

    get confirmNewPassword() {
        return this.flattenedErrors['confirmNewPassword'];
    }
}

export default AccountPassFormErrorModel;



// WEBPACK FOOTER //
// ./client/app/pages/settings/component/account-pass/model/form-error.model.js